import {
  call,
  put,
  select,
  takeLatest
} from 'redux-saga/effects'

import { userRoles } from '@/redux/auth/selectors'
import * as ExercisesAPI from '@/services/exercise'
import { UserRole } from '@/types'
import {
  getExercisesFailed,
  getExercisesRequest,
  getExercisesSuccess
} from './actions'
import type {
  ExerciseModel
} from './types'

function * getExercisesSaga () {
  const roles: UserRole[] = yield select(userRoles)

  try {
    const exercisesData: ExerciseModel[] = yield call(
      ExercisesAPI.getExercisesData, { roles }
    )

    if (exercisesData) {
      yield put(getExercisesSuccess({ exercisesData }))
    } else {
      yield put(getExercisesFailed())
    }
  } catch (err) {
    yield put(getExercisesFailed())
  }
}

function * exercisesSaga () {
  yield takeLatest(getExercisesRequest.type, getExercisesSaga)
}

export default exercisesSaga
